import {
  FETCH_STOCK_TRANSFER_REPORT_REQUEST,
  FETCH_STOCK_TRANSFER_REPORT_SUCCESS,
  FETCH_STOCK_TRANSFER_REPORT_ERROR,
  FETCH_STOCK_TRANSFER_MISSION_BLOCK_REQUEST,
  FETCH_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS,
  FETCH_STOCK_TRANSFER_MISSION_BLOCK_ERROR,
  SAVE_STOCK_TRANSFER_MISSION_BLOCK_REQUEST,
  SAVE_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS,
  SAVE_STOCK_TRANSFER_MISSION_BLOCK_ERROR,
  UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_ERROR,
  UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_REQUEST,
  UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS
} from 'actionTypes'

const DEFAULT_STATE = {
  error: null,
  isFetching: false,
  isSaving: false,
  isUpdating: false,
  updateSucess: null,
  list: [],
  missionBlockError: null,
  missionBlockList: [],
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_REQUEST:
      return {
        ...state,
        isUpdating: true
      }
    case UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_ERROR:
      return {
        ...state,
        isUpdating: false,
        error: action.payload,
        updateSucess: false
      }
    case UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        updateSucess: true
      }
    case FETCH_STOCK_TRANSFER_REPORT_REQUEST:
      return {
        ...state,
        error: null,
        isFetching: true,
      }

    case FETCH_STOCK_TRANSFER_REPORT_SUCCESS:
      return {
        ...state,
        error: null,
        isFetching: false,
        list: action.payload,
      }

    case FETCH_STOCK_TRANSFER_REPORT_ERROR:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      }

    case FETCH_STOCK_TRANSFER_MISSION_BLOCK_REQUEST:
      return {
        ...state,
        isFetching: true,
        missionBlockError: null,
      }

    case FETCH_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS:
      return {
        ...state,
        isFetching: false,
        missionBlockError: null,
        missionBlockList: action.payload,
      }

    case FETCH_STOCK_TRANSFER_MISSION_BLOCK_ERROR:
      return {
        ...state,
        isFetching: false,
        missionBlockError: action.payload,
      }

    case SAVE_STOCK_TRANSFER_MISSION_BLOCK_REQUEST:
      return {
        ...state,
        isSaving: true,
        missionBlockError: null,
      }

    case SAVE_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS:
      return {
        ...state,
        isSaving: false,
        missionBlockError: null,
      }

    case SAVE_STOCK_TRANSFER_MISSION_BLOCK_ERROR:
      return {
        ...state,
        isSaving: false,
        missionBlockError: action.payload,
      }

    default:
      return state
  }
}
